// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
    width: 100%;
    padding: 2rem 1.25rem;
}

.contact h2 {
    margin-bottom: 1rem;
    font-size: 2rem;
}

.contact form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.contact input,
.contact textarea {
    width: 100%;
    padding: 1rem;

    border: 1px solid #d1d1d1;
    border-radius: 0.25rem;

    font-size: 1rem;
    font-family: inherit;

    background-color: #fff;
    color: #222;
}

.contact textarea {
    resize: vertical;
    min-height: 160px;
}

.contact input:focus,
.contact textarea:focus {
    outline: none;
    border-color: #2563eb;
}

.contact button {
    padding: 1rem;

    border: none;
    border-radius: 0.25rem;

    font-size: 1rem;
    font-weight: 600;

    cursor: pointer;

    transition: opacity 0.2s ease;
}

.contact button:hover {
    opacity: 0.85s;
}`, "",{"version":3,"sources":["webpack://./src/components/Contact/contact.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,aAAa;;IAEb,yBAAyB;IACzB,sBAAsB;;IAEtB,eAAe;IACf,oBAAoB;;IAEpB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;;IAEb,YAAY;IACZ,sBAAsB;;IAEtB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;;IAEf,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".contact {\n    width: 100%;\n    padding: 2rem 1.25rem;\n}\n\n.contact h2 {\n    margin-bottom: 1rem;\n    font-size: 2rem;\n}\n\n.contact form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.contact input,\n.contact textarea {\n    width: 100%;\n    padding: 1rem;\n\n    border: 1px solid #d1d1d1;\n    border-radius: 0.25rem;\n\n    font-size: 1rem;\n    font-family: inherit;\n\n    background-color: #fff;\n    color: #222;\n}\n\n.contact textarea {\n    resize: vertical;\n    min-height: 160px;\n}\n\n.contact input:focus,\n.contact textarea:focus {\n    outline: none;\n    border-color: #2563eb;\n}\n\n.contact button {\n    padding: 1rem;\n\n    border: none;\n    border-radius: 0.25rem;\n\n    font-size: 1rem;\n    font-weight: 600;\n\n    cursor: pointer;\n\n    transition: opacity 0.2s ease;\n}\n\n.contact button:hover {\n    opacity: 0.85s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
